module.exports = __webpack_public_path__ + "jquery-ui.e7d767e3810394964943.ttf";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/jquery-ui.ttf?uyccen
// module id = ../../../../../client/assets/fonts/jquery-ui.ttf?uyccen
// module chunks = styles